import React from 'react';
import styled from 'styled-components';
import { maxWidth, retina } from 'Utils/utilsStyle';

type Props = {
  xiqAppPercentage?: string,
  dailyIqPercentage?: string,
  alertPercentage?: string,
} | typeof defaultProps;

const defaultProps = {
  xiqAppPercentage: '0%',
  dailyIqPercentage: '0%',
  alertPercentage: '0%',
};

const Wrapper = styled.div`
  &.nesting-table {
   width: 100%;
   height: 30px;
   display: flex;
   z-index: 0;
   align-items: center;
   padding-top: 5px;
   .table-item {
     height: 100%;
     padding: 5px 0px;
    &.progress-bar {
      height: 25px;
      margin-top: 0;
      width: 100%;
      display: flex;
      z-index: 1;
    }
    &:nth-child(1){
      width: 100%;
      min-width: 6.2%;
      text-align:center;
      padding-right: 50px;
    }
    &:nth-child(2){
      width: 17.1%;
      min-width: 17.1%;
      padding-right: 15px;
      text-align: right;
      display: flex;
      justify-content: flex-end;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        width: 25%;
        min-width: 25%;
      }
    }
    &:nth-child(3){
      width: 68.8%;
      min-width: 68.8%;
      text-align: center;
    }
   }

  }
  .ant-popover  {
    z-index: 3;
  }
  .ant-popover-inner-content {
    padding: 0px !important;
  }
  .ant-popover-inner {
    border-radius: 8px !important;
  }
`;

const NestingStatsBar = function NestingStatsBar(props: Props) {
  const {
    xiqAppPercentage, dailyIqPercentage, alertPercentage,
  } = props;
  return (
    <Wrapper className="nesting-table">
      <div className="table-item progress-bar">
        <div className="blue-line" style={{ width: `${xiqAppPercentage || ''}`, backgroundColor: '#1D8AD2' }} />
        <div className="yellow-line" style={{ width: `${dailyIqPercentage || ''}`, backgroundColor: '#FECB03' }} />
        <div className="green-line " style={{ width: `${alertPercentage || ''}`, backgroundColor: '#1EC252' }} />
      </div>
    </Wrapper>
  );
};

NestingStatsBar.defaultProps = defaultProps;
export default NestingStatsBar;
